module.exports = __webpack_public_path__ + "img/Hypaspist64_ua.87b73f90.webp";